/* eslint-disable eqeqeq */
import Immutable from "immutable";

const divisionsSelector = series => series.rankingsDivisions || series.rankings_divisions;

export const getSelectionsFromSeries = (series, isDirectorRoute, location) => {
    const { searchSeries, searchDivision, filter } = getLocationSelection(location),
        seriesList = (series || []),
        seriesOptions = isDirectorRoute ? seriesList : seriesList.filter(s => divisionsSelector(s).length),
        selectedSeries = (searchSeries && seriesOptions.find(s => s.name.trim() === searchSeries.trim() || s.id == searchSeries.trim())) || seriesOptions[0] || {},
        divisions = divisionsSelector(selectedSeries) || [],
        selectedDivision = (searchDivision && divisions.find(d => d.name.trim() === searchDivision.trim() || d.id == searchDivision.trim())) || divisions[0] || {},
        searchedFound = (searchSeries && (selectedSeries.id === searchSeries.trim() || selectedSeries.name?.trim() === searchSeries.trim()) &&
            ((searchDivision && (selectedDivision.id === searchDivision.trim() || selectedDivision.name?.trim() === searchDivision.trim())) || !searchDivision)) || !searchSeries;

    return { seriesOptions, selectedSeries, divisions, selectedDivision, searchedFound, filter };
};

export const getLocationSelection = (location) => {
    const searchParams = new URLSearchParams(location.search);
    const searchSeries = searchParams.get("series");
    const searchDivision = searchParams.get("division");
    const filter = searchParams.get("filter");

    return { searchSeries: searchSeries && decodeURIComponent(searchSeries), searchDivision: searchDivision && decodeURIComponent(searchDivision), filter: filter && decodeURIComponent(filter) };
};

export const getRankingsPath = (series, division, filter) => {
    let path = `?series=${encodeURIComponent(series)}`;
    if (division)
        path += `&division=${encodeURIComponent(division)}`;
    if (filter)
        path += `&filter=${encodeURIComponent(filter)}`;

    return path;
};

export const changeLocation = (series, division, historyMethod, filter) => historyMethod({ search: getRankingsPath(series, division, filter) });

export const mapStateToProps = (state, props) => ({
    seriesRankings: state.series.get("rankings", Immutable.Map()).toJS(),
    allSeries: state.organisations.get("series")?.toJS(),
    organisation: state.organisations.get("current")?.toJS()
});

export const selectSeries = (location, history, seriesOptions) => e => {
    const { searchDivision } = getLocationSelection(location),
        selectedSeriesId = e.target.value,
        selected = seriesOptions.find(s => s.id == selectedSeriesId),
        divisions = divisionsSelector(selected),
        selectedDivisionId = divisions.find(d => d.id == searchDivision) ?
            searchDivision : divisions[0]?.id;

    changeLocation(selectedSeriesId, selectedDivisionId, history.push);
};

export const selectDivision = (location, history, seriesOptions) => e => changeLocation(getLocationSelection(location).searchSeries || seriesOptions[0].id, e.target.value, history.push);

export const selectFilter = (location, history) => filter => {
    const { searchSeries, searchDivision } = getLocationSelection(location);
    changeLocation(searchSeries, searchDivision, history.push, filter);
};
